import React from 'react';
import exhibitcoinimg from './assets/exhibitcoin.png';

function Exhibitcoin() {
  return (
    <div>
      <h2>exhibitcoin</h2>
      <a 
        href="https://exhibitcoin.art" 
        style={{ 
          color: 'rgb(170, 170, 170)', 
          textDecoration: 'underline', 
          fontStyle: 'italic' 
        }} 
        target="_blank" 
        rel="noopener noreferrer"
      >
        exhibitcoin.art
      </a>

      <div style={{ marginTop: '15px' }}>
        <p>exhibitcoin allows you to easily explore inscriptions associated to any wallet address</p>
        <p>art on bitcoin, just art, nothing else</p>
        <p>beta 0.2.1</p>
        <img 
          src={exhibitcoinimg} 
          alt="Exhibitcoin" 
          style={{ 
            width: '100%', 
            maxWidth: 820, 
            display: 'block', 
            height: 'auto'
          }} 
        />
      </div>
    </div>
  );
}

export default Exhibitcoin; 